import React from "react";
import classes from "./index.module.scss";

export function SecondContent() {
  return (
    <section className={classes.wrapper}>
      <p>
        Để được hỗ trợ, Quý khách vui lòng liên hệ Tổng đài{" "}
        <span className={`${classes.redText} ${classes.boldText}`}>
          18001247
        </span>{" "}
        (miễn cước) hoặc gửi email tới{" "}
        <span className={`${classes.redText} ${classes.boldText}`}>
          customer.service@prudential.com.vn
        </span>
      </p>
    </section>
  );
}
